import StudentAppointmentNotification from "./StudentAppointmentNotification.vue"
import AdultSummaryReportNotification from "./AdultSummaryReportNotification.vue"
import AdultAppointmentNotification from "./AdultAppointmentNotification.vue"

export const notificationMappings = {
  SUMMARY_REPORT_REQUEST_NOTIFICATION: "AdultSummaryReportNotification",
  STUDENT_APPOINTMENT_NOTIFICATION: "StudentAppointmentNotification",
  ADULT_APPOINTMENT_NOTIFICATION: "AdultAppointmentNotification"
}

export const notificationComponents = {
  StudentAppointmentNotification,
  AdultSummaryReportNotification,
  AdultAppointmentNotification
}
